import React from 'react';

const FAQ = () => {
const faqData = [
  {
    question: "What kind of projects do you typically work on?",
    answer:
      "I specialize in designing and developing modern, responsive websites for startups, creative studios, and small businesses — with a focus on storytelling, functionality, and clean UX/UI.",
  },
  {
    question: "Do you only design websites?",
    answer:
      "Not at all. In addition to web design and development, I also provide services like branding, creative direction, performance optimization, and SEO to help brands stand out and grow.",
  },
  {
    question: "How do you approach a new project?",
    answer:
      "Every project starts with a conversation. I dive deep into your brand, goals, and audience before crafting a custom digital experience tailored to your needs.",
  },
  {
    question: "Can you handle both design and development?",
    answer:
      "Yes — I bridge both worlds. From crafting pixel-perfect designs in Figma to bringing them to life with React, GSAP, or Next.js, I offer full-stack design-to-dev execution.",
  },
  {
    question: "Are you open to freelance or remote collaborations?",
    answer:
      "Absolutely. I’m open to freelance projects, collaborations, and remote partnerships — whether it's a one-time gig or long-term creative support.",
  },
];


  return (
    <section className="faq">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <div className="intro">
              <h3 className="title">Frequently Asked Questions</h3>
            </div>
          </div>
        </div>

        <div className="row justify-content-center mt-4">
          <div className="col-12 col-md-10">
            <div className="accordion accordion-flush" id="brilio-accordion">
              {faqData.map((faq, index) => (
                <div className="accordion-item" key={index}>
                  <h4 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index + 1}`}
                    >
                      {faq.question}
                    </button>
                  </h4>
                  <div
                    id={`collapse${index + 1}`}
                    className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                    data-bs-parent="#brilio-accordion"
                  >
                    <div className="accordion-body">{faq.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
